import styled from "styled-components";
import { cardTitleColor } from "../../styles/theme";

export const SocContainer = styled.div`
    width: 100%;
    max-width: 768px;
    margin: 0 auto;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: start;
    padding: 40px 20px 0 20px;
`;

export const Title = styled.div`
    width: 100%;
    text-align: center;
    font-size: 1.5rem;
    font-weight: 500;
    color: ${cardTitleColor};
`;

export const SocContent = styled.div`
    width: 100%;
    display: flex;
    gap: 8px;
    flex-direction: row;
    align-items: center;
    padding: 20px 0px;
    border-bottom: 1px solid #e0e0e0;
`;

export const Select = styled.select`
    width: 100px;
    height: 40px;
    background-color: #ffffff;
    border: 1px solid #e0e0e0;
    border-radius: 30px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 500;
    color: ${cardTitleColor};
`;